import AsynchronousAutocomplete from "../../../components/Autocomplete/AsynchronousAutocomplete";
import { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import Tooltip from "@mui/material/Tooltip";
import React from "react";
import { Box } from "@mui/material";
import { _request } from "../../../http";

export default function MenukaartCell(props) {
  const { row, isEditable } = props;
  const mapping = {
    dbfield: "menukaart.id",
    inputtype: "Async",
    editable: true,
    async: {
      url: `core/kaarten/search?fields=id as value,naam as label&per_page=1000&sort_field=naam&sort_dir=asc&vestiging_id=${row.vestiging_id}`,
      searchField: "naam",
    },
    nullValue: 0,
  };

  if (row.vestiging?.appTarget === "appv5.js") {
    // show multi selector
    mapping.multiple = true;
    mapping.value = row.menukaart.map((menukaart) => {
      return { value: menukaart.id, label: menukaart.naam };
    });
  } else {
    if (row.menukaart?.length > 1) {
      mapping.titleOnHover = {
        tKey: "product.jamezzTable.multiMenukaartFeature.onHoverTitle",
        tDefault:
          "Multiple menus will soon be available in Jamezz V5! In older versions multiple menus won't be supported!",
      };

      // show multi selector
      mapping.multiple = true;
      mapping.value = row.menukaart.map((menukaart) => {
        return { value: menukaart.id, label: menukaart.naam };
      });
    } else if (row.menukaart[0]?.id) {
      // show single selector
      mapping.value = {
        label: row.menukaart[0].naam,
        value: row.menukaart[0].id,
      };
    }
  }

  let tableCellData;

  const autocompleteEl = (
    <AsynchronousAutocomplete
      async={{
        url: `core/kaarten/search?fields=id as value,naam as label&per_page=1000&sort_field=naam&sort_dir=asc&vestiging_id=${row.vestiging_id}`,
        searchField: "naam",
      }}
      key={props.row.id}
      multiple={mapping.multiple}
      onChange={(_, option) => {
        // this option only when is multi
        if (Array.isArray(option) && mapping.multiple) {
          const body = new FormData();
          body.set("menukaart.id", JSON.stringify(option.map((o) => o.value)));
          _request("patch", "core/producten/" + props.row.id, body, {
            showSpinner: false,
          });
        } else if (option) {
          const body = new FormData();
          body.set("menukaart.id", option.value);
          _request("patch", "core/producten/" + props.row.id, body, {
            showSpinner: false,
          });
        } else {
          const body = new FormData();
          body.set("menukaart.id", option);
          _request("patch", "core/producten/" + props.row.id, body, {
            showSpinner: false,
          });
        }
      }}
      value={mapping.value}
    />
  );
  if (mapping.titleOnHover) {
    let title = getTranslation(mapping.titleOnHover.tKey, mapping.titleOnHover.tDefault);
    tableCellData = (
      <Tooltip title={title}>
        <Box style={{ width: 200 }}>{autocompleteEl}</Box>
      </Tooltip>
    );
  } else {
    tableCellData = <Box style={{ width: 200 }}>{autocompleteEl}</Box>;
  }
  return tableCellData;
}
